const reducer = (state, action) => {
	switch (action.type) {
		case 'HANDLE DRAWER':
			return {...state, drawer: action.open};
		case 'CHANGE PAGE':
			return {...state, pageType: action.pageType || state.pageType, pageNo: state.pageNo + action.direction};
		case 'GOTO PAGE':
			return {...state, pageType: action.pageType || state.pageType, pageNo: action.pageNo};
		case 'SELECT POI':
			return {
				...state,
				originalPoi: JSON.parse(JSON.stringify(action.poi)),
				poi: action.poi,
				pageNo: state.pageNo + action.direction,
			};
		case 'EDIT POI':
			return {
				...state,
				poi: action.poi,
			};
		case 'SAVE POIS':
			return {...state, pois: action.pois};

		default:
			return state;
	}
};
export default reducer;
